import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import DOMPurify from "dompurify";

import { store } from "../..";
import "../../assets/css/wibb/pages/home.scss";
import {
    globalActions,
    selectSetting,
} from "../../features/global/globalSlice";
import { useAppSelector } from "../../hooks/reduxHooks";

export const loader = async () => {
    const settings = store.getState().global.settings;

    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    await Promise.all([settingsPromise]);

    return null;
};

const Vetting = (): React.JSX.Element => {
    const content = useAppSelector(state =>
        selectSetting(state, "wibb_vetting"),
    );

    return (
        <Container className="py-5 vettingContent" data-testid="vettingContent">
            <Row>
                <Col
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(content?.setting),
                    }}
                />
            </Row>
        </Container>
    );
};

export default Vetting;
